import type { ErrorInfo } from "react";
import type { RootOptions } from "react-dom/client";
import { AppErrorBoundary } from "./AppErrorBoundary";
import { reportError } from "./telemetry";

const trimStack = (stack?: string | null) => stack?.trim().split("\n").slice(0, 12).join("\n");

/** React root error hooks; render crashes caught by boundaries or escaping them are reported once here. */
export const reactRootErrorHandlers = {
  onCaughtError(error: unknown, info: ErrorInfo & { errorBoundary?: unknown }) {
    const scope = info.errorBoundary instanceof AppErrorBoundary ? info.errorBoundary.props.scope : "component";
    reportError(error, {
      source: `react.boundary.${scope}`,
      fatal: scope === "app",
      context: { componentStack: trimStack(info.componentStack) },
    });
    console.error(error);
  },
  onUncaughtError(error: unknown, info: ErrorInfo) {
    reportError(error, { source: "react.uncaught", fatal: true, context: { componentStack: trimStack(info.componentStack) } });
    console.error(error);
  },
  onRecoverableError(error: unknown, info: ErrorInfo) {
    reportError(error, { source: "react.recoverable", context: { componentStack: trimStack(info.componentStack) } });
    console.warn(error);
  },
} satisfies Pick<RootOptions, "onCaughtError" | "onUncaughtError" | "onRecoverableError">;
